// EDIT THIS TEXT FOR FINAL COPY
// This file contains all editable content for the Future of Media London 2026 download page.
// The email itself is set in functions/sendDownloadEmail.js under 'future-of-media-2026'.

export const FUTURE_OF_MEDIA_2026_CONTENT = {
  // Page metadata
  pageTitle: 'Agentic knowledge | Future of Media London 2026 | Syllepsis',
  pageDescription: 'The slides from the Syllepsis session at Future of Media London 2026',

  // Page header
  eyebrow: 'Future of Media London 2026',
  headerTitle: 'What do your agents know?',
  headerSubtitle:
    'Knowledge versus data, and what a knowledge architecture gives your AI agents. Enter your details and we will email you the slides, with the two plans the AI produced live in the session.',

  // Form labels and validation
  form: {
    nameLabel: 'Full name',
    namePlaceholder: 'Your full name',
    emailLabel: 'Work email',
    emailPlaceholder: 'your.email@company.com',
    consentLabel: 'I agree to receive the slides and plans by email and to be contacted by Syllepsis about related services.',
    submitButton: 'Email me the slides',
    submittingButton: 'Sending...',
  },

  // Success/Error messages
  messages: {
    success: 'Thank you. The slides and plans are on their way, so check your inbox in a minute or two.',
    error: 'Something went wrong. Please try again or email us at info@syllepsis.io.',
  },
}
